<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_badge") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #7514b7">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Name Input (Arabic) -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('PLACEHOLDERS.badge_name') + ' (' + $t('PLACEHOLDERS.ar') + ')'
            "
            v-model.trim="data.nameAr"
            :maxlength="32"
            required
          />
          <!-- End:: Name Input (Arabic) -->

          <!-- Start:: Name Input (English) -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('PLACEHOLDERS.badge_name') + ' (' + $t('PLACEHOLDERS.en') + ')'
            "
            v-model.trim="data.nameEn"
            :maxlength="32"
            required
          />
          <!-- End:: Name Input (English) -->

          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="badge_image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.badge_image')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Points Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.points')"
            v-model.number="data.points"
            min="0"
            required
          />
          <!-- End:: Points Input -->
          <!-- Start:: gender  Select -->
          <base-select-input
            col="6"
            :optionsList="genders"
            :placeholder="$t('PLACEHOLDERS.gender')"
            v-model="data.gender"
            required
          />
          <!-- End:: gender  Select -->
          <!-- Start:: Activity Select -->
          <base-select-input
            col="6"
            :optionsList="activities"
            :placeholder="$t('PLACEHOLDERS.activity')"
            v-model="data.activity"
            required
          />
          <!-- End:: Activity Select -->

          <!-- Start:: Earn Condition Select -->
          <base-select-input
            col="6"
            :optionsList="earnConditions"
            :placeholder="$t('PLACEHOLDERS.earn_condition')"
            v-model="data.earnCondition"
            required
          />
          <!-- End:: Earn Condition Select -->

          <!-- Start:: Earn Condition Value Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.earn_condition_value')"
            v-model.number="data.earnConditionValue"
            min="0"
            step="0.01"
            required
          />
          <!-- End:: Earn Condition Value Input -->

          <!-- Start:: Period Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.period_days')"
            v-model.number="data.period"
            min="1"
            required
          />
          <!-- End:: Period Input -->

          <!-- Start:: Activation Switch Input -->
          <div class="input_wrapper switch_wrapper my-5 col-6">
            <v-switch
              color="green"
              :label="
                data.isActive
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.isActive"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Activation Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import BaseImageUploadInput from "../../../components/formInputs/BaseImageUploadInput.vue";

export default {
  name: "EditBadge",

  components: { BaseImageUploadInput },

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        nameAr: null,
        nameEn: null,
        points: null,
        activity: null,
        earnCondition: null,
        earnConditionValue: null,
        period: null,
        isActive: true,
      },
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Activities List
    activities() {
      return [
        { id: 1, name: this.$t("ACTIVITIES.walking_running"), value: 1 },
        { id: 2, name: this.$t("ACTIVITIES.cycling"), value: 2 },
        { id: 3, name: this.$t("ACTIVITIES.horse_riding"), value: 3 },
      ];
    },
    genders() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.male"),
          value: "male",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.female"),
          value: "female",
        },
        { id: 3, name: this.$t("PLACEHOLDERS.all"), value: "all" },
      ];
    },
    // Earn Conditions List
    earnConditions() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.steps_condition"),
          value: "steps",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.distance_condition"),
          value: "distance",
        },
      ];
    },
  },

  methods: {
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      this.submitForm();
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();

      // Start:: Append Request Data
      if (this.data.nameAr) {
        REQUEST_DATA.append("name[ar]", this.data.nameAr);
      }
      if (this.data.nameEn) {
        REQUEST_DATA.append("name[en]", this.data.nameEn);
      }
      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }
      if (this.data.points) {
        REQUEST_DATA.append("points", this.data.points);
      }
      if (this.data.gender) {
        REQUEST_DATA.append("gender", this.data.gender.value);
      }
      if (this.data.activity) {
        REQUEST_DATA.append("activity_id", this.data.activity.value);
      }
      if (this.data.earnCondition) {
        REQUEST_DATA.append("earn_condition", this.data.earnCondition.value);
      }
      if (this.data.earnConditionValue) {
        REQUEST_DATA.append(
          "earn_condition_value",
          this.data.earnConditionValue
        );
      }
      if (this.data.period) {
        REQUEST_DATA.append("period", this.data.period);
      }
      REQUEST_DATA.append("is_active", this.data.isActive ? 1 : 0);
      REQUEST_DATA.append("_method", "PUT");
      // End:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `badges/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/badges/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Load Badge Data
    async loadBadgeData() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `badges/${this.$route.params.id}`,
        });

        const badge = res.data.data.Badge;

        // Set badge data
        this.data.nameAr = badge.trans?.name?.ar || badge.name;
        this.data.nameEn = badge.trans?.name?.en || badge.name;
        this.data.image.path = badge.image;
        this.data.points = badge.points;
        this.data.earnConditionValue = parseFloat(badge.earn_condition_value);
        this.data.period = badge.period;
        this.data.isActive = badge.is_active;
        this.data.gender = this.genders.find((g) => g.value === badge?.gender);

        // Set activity
        const activity = this.activities.find(
          (a) => a.value === badge.activity_id
        );
        if (activity) {
          this.data.activity = activity;
        }

        // Set earn condition
        const earnCondition = this.earnConditions.find(
          (e) => e.value === badge.earn_condition
        );
        if (earnCondition) {
          this.data.earnCondition = earnCondition;
        }
      } catch (error) {
        console.log(error.response?.data?.message);
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.somethingWrong")
        );
      }
    },
    // End:: Load Badge Data
  },

  created() {
    // Start:: Fire Methods
    this.loadBadgeData();
    // End:: Fire Methods
  },
};
</script>
